module.exports = __webpack_public_path__ + "static/media/census-bg.f13c86f5.jpg";